import { RobotActions, RobotDetails, RobotInfo, RobotSettings } from './types';

export const getRobotInfo = async (
  robotIp: string | undefined
): Promise<RobotInfo> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/info`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot info returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const getRobotDetails = async (
  robotIp: string | undefined
): Promise<RobotDetails> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/info/details`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot details returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const getRobotSettings = async (
  robotIp: string | undefined
): Promise<RobotSettings> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/info/settings`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot settings returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const updateRobotSettings = async (
  robotIp: string | undefined,
  updates: Partial<RobotSettings>
): Promise<{ [k in keyof RobotSettings]?: boolean | null }> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/info/settings`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error(
      `Updating Robot Settings returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const getRobotActions = async (
  robotIp: string | undefined
): Promise<RobotActions> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/info/actions`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot actions returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};
